import '../styles/Footer.css';

const companyUrl = 'https://www.allabolag.se/foretag/execora-consulting-ab/j%C3%B6nk%C3%B6ping/uthyrning/2KHXO4HI5YIEZ';

const footerContent = {
  swe: {
    orgLabel: 'Org.nr 559301-2577',
    companyName: 'Execora Consulting AB',
    rights: 'All rights reserved.',
    builtBy: 'Denna sida är fullt utvecklad av Arya Eisa'
  },
  eng: {
    orgLabel: 'org number 559301-2577',
    companyName: 'Execora Consulting AB',
    rights: 'All rights reserved.',
    builtBy: 'This site is fully developed by Arya Eisa'
  }
};

function Footer({ lang = 'swe' }) {
  const currentYear = new Date().getFullYear();
  const text = footerContent[lang] || footerContent.swe;

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <a
          className="footer-link footer-col footer-col-left"
          href={companyUrl}
          target="_blank"
          rel="noreferrer"
        >
          <span className="footer-line">{text.orgLabel}</span>
          <span className="footer-line">{text.companyName}</span>
        </a>

        <p className="footer-text footer-col footer-col-center">
          <span className="footer-line">© {currentYear} Execora Consulting AB</span>
          <span className="footer-line">{text.rights}</span>
        </p>

        <p className="footer-text footer-col footer-col-right">
          <span className="footer-line">{text.builtBy}</span>
          <a
            className="footer-link footer-line footer-builtby-link"
            href="https://www.aryaeisa.com"
            target="_blank"
            rel="noreferrer"
          >
            www.aryaeisa.com
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
